import { render, staticRenderFns } from "./ItemsReceivedListFilterRep.vue?vue&type=template&id=053d119a&"
import script from "./ItemsReceivedListFilterRep.vue?vue&type=script&lang=js&"
export * from "./ItemsReceivedListFilterRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports